import { map, filter } from 'lodash';

export const days = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];

const dataFromApi = '12345671234567';

const calculateArrivalDays = allDays => allDays.substr(0, 7).split('');
const calculateDepartureDays = allDays => allDays.substr(7, 13).split('');

const generateDays = typeOfDays =>
  days.reduce((acc, cur, index) => {
    return { ...acc, [cur]: typeOfDays[index] === '_' ? false : true };
  }, {});

export const arrivalDays = (allDays = dataFromApi) => generateDays(calculateArrivalDays(allDays));

export const departureDays = (allDays = dataFromApi) =>
  generateDays(calculateDepartureDays(allDays));

export const prepareDaysForApi = arrival => {
  const dayNumber = map(days, day => {
    if (arrival[day] === false) {
      return '_';
    }

    const currentIndex = days.findIndex(currentDay => currentDay === day);

    return currentIndex + 1;
  });

  return dayNumber.join('');
};

const filterArrivalDays = filter(calculateArrivalDays(dataFromApi), day => day !== '_');
const filterDepartureDays = filter(calculateArrivalDays(dataFromApi), day => day !== '_');

export const arrivalDaysArray = () => map(filterArrivalDays, newDay => days[+newDay - 1]);
export const departureDaysArray = () => map(filterDepartureDays, newDay => days[+newDay - 1]);
